import { render, staticRenderFns } from "./accordion-header.vue?vue&type=template&id=153be75b&"
import script from "./accordion-header.vue?vue&type=script&lang=js&"
export * from "./accordion-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports